import React from "react";
import type { NewMentor } from "../../contexts/HackathonContext";
import { groups } from "../../data/groups";
import { PhotoInput } from "./PhotoInput";
import { inputClass, labelClass } from "./fieldStyles";
interface MentorFieldsProps {
  value: NewMentor;
  onChange: (value: NewMentor) => void;
  mode: "self" | "admin";
}
export function MentorFields({
  value,
  onChange,
  mode
}: MentorFieldsProps) {
  const set = <K extends keyof NewMentor,>(key: K, v: NewMentor[K]) => onChange({
    ...value,
    [key]: v
  });
  const toggleGroup = (id: number) => set("groupIds", value.groupIds.includes(id) ? value.groupIds.filter(g => g !== id) : [...value.groupIds, id].sort());
  return <div className="space-y-5" data-id="element-211" data-mp="28boo2g963e1o">
      <PhotoInput name={value.name} school="mentor" value={value.photo} onChange={p => set("photo", p)} data-id="element-212" data-mp="28cggxjbdqxo9" />

      <label className="block" data-id="element-213" data-mp="hzr64zj22nu9">
        <span className={labelClass} data-id="element-214" data-mp="i0sqjulyomon">Full name</span>
        <input required value={value.name} onChange={e => set("name", e.target.value)} className={inputClass} data-id="element-215" data-mp="dyfll8f1gssx" />
      </label>

      <div className="grid gap-5 sm:grid-cols-2" data-id="element-216" data-mp="19ahck0pl3f01">
        <label className="block" data-id="element-217" data-mp="1e77p4e26jsgp">
          <span className={labelClass} data-id="element-218" data-mp="1e8agen3ezwx5">Company / organization</span>
          <input value={value.organization} onChange={e => set("organization", e.target.value)} className={inputClass} data-id="element-219" data-mp="1j6kcr10vl3kc" />
        </label>
        <label className="block" data-id="element-220" data-mp="1nyvco3vm8pcw">
          <span className={labelClass} data-id="element-221" data-mp="1swndjne8nlt8">Expertise</span>
          <input value={value.expertise} onChange={e => set("expertise", e.target.value)} placeholder="e.g. Embedded systems, GTM" className={inputClass} data-id="element-222" data-mp="1sw3w07si2zfq" />
        </label>
      </div>

      {mode === "admin" && <fieldset data-id="element-223" data-mp="26woef2ui6t8p">
          <legend className={labelClass} data-id="element-224" data-mp="26vwkdwgk13kj">Mentoring groups</legend>
          <div className="mt-2 flex flex-wrap gap-2" data-id="element-225" data-mp="7ju2gqnkwh8z">
            {groups.map(g => {
          const on = value.groupIds.includes(g.id);
          return <button key={g.id} type="button" role="checkbox" aria-checked={on} onClick={() => toggleGroup(g.id)} className={`rounded-lg border px-3 py-1.5 text-sm font-semibold transition-colors duration-150 ${on ? "border-navy bg-navy text-white" : "border-line bg-surface text-muted hover:text-ink"}`} data-id="element-226" data-mp="ck8boc0x1x8l">
                  Group {g.id}
                </button>;
        })}
          </div>
        </fieldset>}

      <div className="grid gap-5 sm:grid-cols-2" data-id="element-227" data-mp="x6ddx4wz6est">
        <label className="block" data-id="element-228" data-mp="x51yu8y2xkme">
          <span className={labelClass} data-id="element-229" data-mp="x8hilp2p7hu5">Email</span>
          <input type="email" value={value.email} onChange={e => set("email", e.target.value)} className={inputClass} data-id="element-230" data-mp="s8bj5mq6sr1i" />
        </label>
        <label className="block" data-id="element-231" data-mp="174swuklumhr8">
          <span className={labelClass} data-id="element-232" data-mp="125q15qrrdnvx">LinkedIn</span>
          <input value={value.linkedin} onChange={e => set("linkedin", e.target.value)} className={inputClass} data-id="element-233" data-mp="127109da9e7gp" />
        </label>
      </div>

      <label className="block" data-id="element-234" data-mp="1psl7ivn7e2si">
        <span className={labelClass} data-id="element-235" data-mp="1prtn8gz23rhj">Short bio</span>
        <textarea rows={4} value={value.bio} onChange={e => set("bio", e.target.value)} className={`${inputClass} resize-none`} data-id="element-236" data-mp="1bt2bh17o2hwk" />
      </label>
    </div>;
}